export type EnvVars = keyof typeof window._env_;

/**
 * Gets env variable from window._env object
 * added in runtime by /static/env-vars.js script
 */
export function getEnvVar(varName: EnvVars, useLocalStoreOverride = false) {
    if (useLocalStoreOverride && localStorage.getItem(varName)) {
        return localStorage.getItem(varName) || '';
    }

    if (!window || !window._env_) {
        return '';
    }

    return window._env_[varName];
}

/**
 * Function to work with boolean-like env variables ("true" or "false" strings).
 *
 * @returns True if env var value is "true" string.
 *
 * @param [useLocalStoreOverride=false] if set to true, will check browser local store first for a variable with provided name.
 * We use this to achieve local store overrides for flag vars (for testing purpose).
 */
export function getEnvFlag(prop: EnvVars, useLocalStoreOverride = false) {
    if (useLocalStoreOverride && localStorage.getItem(prop)) {
        return localStorage.getItem(prop) === 'true';
    }

    return getEnvVar(prop) === 'true';
}
